export const BASE_URL = 'https://sibbrands.ru/api/v1/';
